
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
           
            <registration-edit *ngSwitchCase="true"></registration-edit>
            <registration-details *ngSwitchCase="false"></registration-details>
        </div>
    </ng-template>  
</main-form-modal>